import { find, get } from "lodash";
import { useRouter } from "next/router";
import { Chip } from "primereact/chip";
import { useState } from "react";
import { twMerge } from "tailwind-merge";
import { useDevices } from "../../../devices/api";
import { useModes } from "../../../energy/api/useModes";
import { MODE_ICONS } from "../../../energy/constants";
import { getModeDeviceStatus } from "../../../energy/utils";
import { ActiveModeModal } from "./ActiveModeModal";

interface ActiveModeChipProps {
    className?: string;
}

const ActiveModeChip = (props: ActiveModeChipProps) => {
    const { className = null } = props;

    const [isModalOpen, setIsModalOpen] = useState(false);

    const router = useRouter();
    const { companyId, locationId } = router.query as {
        companyId?: string;
        locationId?: string;
    };

    const { modes } = useModes({
        companyId,
        locationId,
    });

    const { devices } = useDevices({
        companyId,
        locationId,
    });

    const activeMode = find(modes, "active") ?? null;

    const { hasFanCoils, hasRadiatorThermostats } = getModeDeviceStatus(
        activeMode,
        devices
    );

    return activeMode ? (
        <>
            <Chip
                onClick={() => {
                    setIsModalOpen(true);
                }}
                icon={get(MODE_ICONS, activeMode.icon!, null)}
                label={activeMode.name}
                pt={{
                    label: {
                        className: "hidden sm:inline ml-1",
                    },
                    root: {
                        className: twMerge(
                            "p-1.5 sm:px-3 sm:py-0 hover:cursor-pointer",
                            className
                        ),
                    },
                }}
            />
            <ActiveModeModal
                isOpen={isModalOpen}
                hasFanCoils={hasFanCoils}
                hasRadiatorThermostats={hasRadiatorThermostats}
                mode={activeMode}
                onClickClose={() => {
                    setIsModalOpen(false);
                }}
            />
        </>
    ) : null;
};

export default ActiveModeChip;
